import { useNavigate } from "react-router-dom";
import logo from "../pages/images/logo/logobgremove.png";
import logotext from "../pages/images/logo/removebggo.png";

export default function CabHeader() {
  const navigate = useNavigate();
  const phoneNumber = "919836904698";

  return (
    <>
      <style>{`

        /* ===== HEADER ===== */
        .cab-header {
          display: flex;
          justify-content: space-between;
          align-items: center;

          padding: 0 16px;
          height: 64px;

          background:#0d2a4a;
          border-bottom: 1px solid #E6D3A3;

          position: sticky;
          top: 0;
          z-index: 1000;
        }

        /* ===== LOGO AREA ===== */
        .cab-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
        }

        /* Logo icon */
        .cab-logo-icon {
          height: 38px;
          width: auto;
        }

        /* Brand text image */
        .cab-logo-text {
          height: 80px;
          width: 100px;
          
          object-fit: contain;
        }

        /* ===== WHATSAPP BUTTON ===== */
        .wa-btn {
          background: linear-gradient(90deg, #C5A047, #FFD700, #B8962E);
          color: #000;

          border: none;
          border-radius: 20px;

          padding: 6px 16px;
          font-size: 13px;
          font-weight: 600;

          display: flex;
          align-items: center;
          gap: 6px;

          cursor: pointer;
          transition: all 0.3s ease;
        }

        .wa-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 2px 8px rgba(212, 175, 55, 0.4);
        }

        /* ===== MOBILE ===== */
        @media (max-width: 768px) {
          .cab-header {
            height: 58px;
            padding: 0 12px;
          }

          .cab-logo-icon {
            height: 32px;
          }

          .cab-logo-text {
            height: 32px;
            max-width: 140px;
          }

          .wa-btn {
            padding: 5px 12px;
            font-size: 12px;
          }
        }

      `}</style>

      <header className="cab-header">
        
        {/* LOGO */}
        <div className="cab-logo" onClick={() => navigate("/orrbiitgo")}>
          <img src={logo} alt="Orrbiit" className="cab-logo-icon" />
          <img src={logotext} alt="Orrbiit Go" className="cab-logo-text" />
        </div>

        {/* WHATSAPP BUTTON */}
        <a
          href={`https://wa.me/${phoneNumber}?text=Hello%20Orrbiit%20Go,%20I%20want%20to%20book%20a%20cab`}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
         <button className="wa-btn"> <i className="bi bi-whatsapp"></i> WhatsApp </button>
        </a>

      </header>
    </>
  );
}